import { CompanyDetail } from '@/domain/usecases/company/company-detail'
import { Company } from '@/domain/models/company/company-model'
import { QueryClient } from 'react-query'
import { queryClient } from '@/infra/http'

export type CompanyDetailLoadDataType = {
  company: Company.Model
}

/**
 * Loads company detail by ID for internal company manager
 * Simple loader that fetches company information
 */
export async function loadCompanyDetail(id: string): Promise<CompanyDetailLoadDataType> {
  const module = await import('@/main/factories/usecases')
  const makeRemote = module.makeRemoteCompanyDetail as (queryClient: QueryClient) => CompanyDetail
  const remoteCompanyDetail = makeRemote(queryClient)

  return {
    company: await remoteCompanyDetail.get(id)
  }
}
